var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-export-validation',{attrs:{"fileType":_vm.fileMeta.type,"fileDate":_vm.fileMeta.date,"feedback":_vm.feedback,"content":_vm.transformed}})}
var staticRenderFns = []

export { render, staticRenderFns }